import api from './api';

/** For free events: send eventId + numberOfTickets. For paid (tiered): send eventId + items. */
export interface CreateCheckoutSessionRequest {
  eventId: number;
  /** Free events only; do not send with items. */
  numberOfTickets?: number;
  /** Paid (tiered) events only; do not send with numberOfTickets. */
  items?: { tierId: number; quantity: number }[];
  /** Required for guest checkout; omit when user is authenticated */
  email?: string;
  /** Guest only; used in confirmation email. Max 255. */
  firstName?: string;
  /** Guest only; used in confirmation email. Max 255. */
  lastName?: string;
}

export interface CreateCheckoutSessionResponse {
  sessionId: string;
  url: string;
}

export const createCheckoutSession = async (
  data: CreateCheckoutSessionRequest
): Promise<CreateCheckoutSessionResponse> => {
  try {
    const response = await api.post<CreateCheckoutSessionResponse>('/payments/create-checkout-session', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  createCheckoutSession,
};

